import {
    useAppDispatch,
    useAppSelector,
} from '../../hooks'
import React from 'react'
import {
    SidebarDialogue,
} from './types'
import {SidebarDialoguesView} from './SidebarDialoguesView'
import {confirmationModal} from '../../actions/modal'
import {listDialogues} from '../../selectors/ninchat'
import {navigation} from '../../navigation'
import {useTranslation} from 'react-i18next'

const SidebarDialogues = (): React.ReactElement => {
    const {t} = useTranslation()

    const dispatch = useAppDispatch()
    const dialogues = useAppSelector(({ninchat}): Array<SidebarDialogue> => listDialogues(ninchat))
    const loadDialogue = (dialogue_id: string): void => {
        navigation.push('Dialogue', {dialogue_id})
    }

    const onHide = (dialogue_id: string) => {
        dispatch(confirmationModal({
            onConfirm: {
                action: 'hideDialogue',
                dialogueId: dialogue_id,
            },
            show: true,
            text: t('Are you sure you wish hide this conversation?'),
            title: t('Hide conversation?'),
        }))
    }

    return (
        <SidebarDialoguesView dialogues={dialogues} loadDialogue={loadDialogue} onHide={onHide} />
    )
}

export default SidebarDialogues
